import { render, staticRenderFns } from "./PointTransferModal.vue?vue&type=template&id=a28eecac&scoped=true&"
import script from "./PointTransferModal.vue?vue&type=script&lang=js&"
export * from "./PointTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./PointTransferModal.vue?vue&type=style&index=0&id=a28eecac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28eecac",
  null
  
)

export default component.exports